// define types for deleteAccountActions and deleteAccountReducer
export const DELETE_ACCOUNT_ON_CHANGE = 'DELETE_ACCOUNT_ON_CHANGE';
